
        (function() {
          const slider = document.querySelector('.announcement-slider-sections--30445710279004__custom_announcement_bar_wY7MGM');
          if (!slider) return;

          const slides = slider.querySelectorAll('.announcement-slide-sections--30445710279004__custom_announcement_bar_wY7MGM');
          if (slides.length < 2) return;

          const prevBtn = slider.querySelector('.announcement-nav-prev-sections--30445710279004__custom_announcement_bar_wY7MGM');
          const nextBtn = slider.querySelector('.announcement-nav-next-sections--30445710279004__custom_announcement_bar_wY7MGM');

          const slideDuration = parseInt(slider.dataset.slideDuration) || 4000;
          const transitionSpeed = parseInt(slider.dataset.transitionSpeed) || 500;
          let currentIndex = 0;
          let isTransitioning = false;
          let autoPlayInterval = null;

          function goToSlide(targetIndex, direction) {
            if (isTransitioning || targetIndex === currentIndex) return;
            isTransitioning = true;

            const currentSlide = slides[currentIndex];
            const nextSlideEl = slides[targetIndex];

            // Make next slide entering (absolute, animating in)
            nextSlideEl.classList.add('entering');
            
            // Force reflow to ensure entering class is applied
            nextSlideEl.offsetHeight;
            
            // Start transition - current becomes previous, next becomes active
            currentSlide.classList.remove('active');
            currentSlide.classList.add('exiting');
            nextSlideEl.classList.remove('entering');
            nextSlideEl.classList.add('active');

            // Clean up after transition completes
            setTimeout(() => {
              currentSlide.classList.remove('exiting');
              currentIndex = targetIndex;
              isTransitioning = false;
            }, transitionSpeed);
          }

          function nextSlide() {
            const nextIndex = (currentIndex + 1) % slides.length;
            goToSlide(nextIndex, 'next');
          }

          function prevSlide() {
            const prevIndex = (currentIndex - 1 + slides.length) % slides.length;
            goToSlide(prevIndex, 'prev');
          }

          function resetAutoPlay() {
            if (autoPlayInterval) {
              clearInterval(autoPlayInterval);
            }
            autoPlayInterval = setInterval(nextSlide, slideDuration);
          }

          // Arrow button event listeners
          if (prevBtn) {
            prevBtn.addEventListener('click', function(e) {
              e.preventDefault();
              prevSlide();
              resetAutoPlay();
            });
          }

          if (nextBtn) {
            nextBtn.addEventListener('click', function(e) {
              e.preventDefault();
              nextSlide();
              resetAutoPlay();
            });
          }

          // Start auto-play
          autoPlayInterval = setInterval(nextSlide, slideDuration);
        })();
      
;

  (function() {
    // Highlight text function
    function highlightText(container, textToHighlight) {
      if (!container || !textToHighlight || textToHighlight.trim() === '') return;
      
      const textSpan = container.querySelector('.announcement-slide-text-sections--30445710279004__custom_announcement_bar_wY7MGM');
      if (!textSpan) return;
      
      const html = textSpan.innerHTML;
      const escapedText = textToHighlight.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const regex = new RegExp('(' + escapedText + ')', 'gi');
      
      if (regex.test(html)) {
        textSpan.innerHTML = html.replace(regex, '<span class="announcement-highlight">$1</span>');
      }
    }
    
    // Apply highlights to each slide
    
      const slide0 = document.querySelector('.announcement-slide-sections--30445710279004__custom_announcement_bar_wY7MGM[data-slide-index="0"]');
      highlightText(slide0, "Nawet do -60%");
    
    
    
    
    
    
    
    
    
    
    // Also handle static single slide
    
      const staticSlide = document.querySelector('.announcement-static-sections--30445710279004__custom_announcement_bar_wY7MGM');
      if (staticSlide) {
        highlightText(staticSlide, "Nawet do -60%");
      }
    
  })();
